import {V1ETLJobExecutionIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import {v4 as uuidv4} from "uuid";
import EnlilAxios from "../../../../util/EnlilAxios";

class ETLJobExecutionEnterpriseComponent extends EnterpriseComponent {
    performSingleRecordRefresh = (primaryKey) => {
        let QBE = {
            "ShifamedMessage": {
                "-idoc": this.getIDOCResponse(),
                "-id": uuidv4(),
                "ETLJobExecution": {
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "primary",
                                "Operator": "AND",
                                "Type": "QueryGroup",
                                "Membership": {
                                    "Member": [
                                    ]
                                }
                            }
                        ]
                    }
                }
            }
        }

        QBE.ShifamedMessage.ETLJobExecution.QueryGroups.QueryGroup[0].Membership.Member.push({
            "Type": "Attribute",
            "Name": "USID",
            "Value": primaryKey,
            "Operator": "EQUAL"
        })

        let options = {
            method: "GET",
            url: "t1/v1/etl_job_executions",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.ETLJobExecution-001",
            },
        };

        this.notifySingleRecordRefreshStartListeners();

        EnlilAxios(options)
            .then(response => {
                this.refreshEnterpriseComponentSuccess(V1ETLJobExecutionIDOCToArray(response.data));
            })
            .catch(error => {
                this.fetchEnterpriseComponentFailed(error);
            });
    };

    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let QBE = {
            "ShifamedMessage": {
                "-idoc": this.getIDOCResponse(),
                "-id": uuidv4(),
                "ETLJobExecution": {
                    '_attributes': {
                        'limit': pageSize,
                        'sort': this.getFormattedSortSpecification(),
                        'offset': (page - 1) * pageSize
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "primary",
                                "Operator": "AND",
                                "Type": "QueryGroup",
                                "Membership": {
                                    "Member": [
                                    ]
                                }
                            }
                        ]
                    }
                }
            }
        }
        let queryPayload = this.prepareQueryPayload();

        if (foreignKey) {
            QBE.ShifamedMessage.ETLJobExecution.QueryGroups.QueryGroup[0].Membership.Member.push({
                "Type": "Attribute",
                "Name": "ETLJobUSID",
                "Value": foreignKey,
                "Operator": "EQUAL"
            })
        }

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;

                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) {
                    operator = queryPayload.get(key + "_query")
                }
                QBE.ShifamedMessage.ETLJobExecution.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": value,
                    "Operator": operator
                })
            }
        }

        EnlilAxios({
            method: "GET",
            url: "t1/v1/etl_job_executions",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.ETLJobExecution-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ETLJobExecutionIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

}

export default ETLJobExecutionEnterpriseComponent;